<template>
  <div class="box" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="title_box">
      <span class="title">钱包转换</span>
    </div>
    <div class="ct_box">
      <div class="ct_box_left">

        <div class="ct_box_title">钱包转换</div>

        <div class="conversionAmount">
          <p class="">转化金额：</p>
          <el-input style="margin: 0 10px" v-model="amount"
                    onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                    oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                    placeholder="转化金额"></el-input>
          <p>元</p>
        </div>

        <div class="money_box">账户-余额：<span>￥{{ user_info.guanggao_money }}</span>元</div>

        <el-button class="conversionBtn" @click="sub" type="primary"><i class="el-icon-sort"></i>确认转换</el-button>

        <div class="money_box">收益-钱包：<span>￥{{ user_info.guanggao_wallet }}</span>元</div>

      </div>
      <div class="ct_box_right">
        <div class="ct_box_title">收益钱包－转换信息统计</div>
        <div class="ct_box_right_item">
          <div class="ct_box_right_item_1_box">
            <span>钱包-余款：<span style="color: rgba(16, 140, 221, 1)">{{ user_info.guanggao_wallet }}</span>元</span>
          </div>
          <div class="ct_box_right_item_1_box">
            <span>已转化-金额：<span style="color: rgba(0, 176, 82, 1)">{{ income.total_zh }}</span>元</span>
          </div>
        </div>
        <div class="ct_box_right_item">
          <div class="ct_box_right_item_1_box">
            <span>提现中-金额：<span style="color:rgba(255, 0, 0, 1);">{{ income.total_tx }}</span>元</span>
          </div>
          <div class="ct_box_right_item_1_box">
            <span>累计收益-金额：<span style="color: rgba(0, 176, 82, 1)">{{ income.total_sr }}</span>元</span>
          </div>
        </div>
        <p class="statement"><i class="el-icon-warning"></i>此界面是收益钱包转换普通钱包(普通钱包用来发稿)</p>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/UserInfoTitle.vue'

export default {
  components: {
    Title,
  },
  computed: {},
  mounted() {
    this.getIncome()
  },
  data() {
    return {
      amount: '',
      fullscreenLoading: false,
      income: [],
      user_info: this.$util.getLocalStorage('user_info'),
    }
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.curlGet('/api/user/info').then((res) => {
        if (res.data.code) {
          this.$user_info = res.data.data
          console.log(this.$user_info, 'user_info');
          this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
        }
      })
    },
    // 收益
    getIncome() {
      this.curlGet('/api/users/guanggao_money_log/income').then((res) => {
        if (res.data.code) {
          this.income = res.data.data
        }
      })
    },
    sub() {
      this.fullscreenLoading = true
      this.curlPost('/api/users/guanggao_tocash/conversion', {
        amount: this.amount,
      }).then((res) => {
        if (res.data.code) {
          this.$message({
            message: '转换成功',
            type: 'success',
          })
          this.getUserInfo()

          setTimeout(() => {
            this.fullscreenLoading = false
            return this.$router.go(0)
          }, 500)
        } else {
          this.fullscreenLoading = false
          return this.$message({
            message: res.data.msg,
            type: 'warning',
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/WalletConversion';
</style>